const members = [
  {
    _id: 'member-001',
    childId: 'child-001',
    name: 'Alicia Johnson',
    relationshipToChild: 'Mother',
    role: 'placement',
    phones: ['+1 (555) 201-3344'],
    emails: ['alicia.johnson@example.com'],
    addresses: ['1420 Maple St, Wichita, KS'],
    commitmentLevel: 'high',
    childComfort: 'high',
    caregiverOpenness: 'medium',
    status: 'engaged',
    lastContactAt: '2025-01-06T20:30:00.000Z',
    sourceProvenance: ['genogram-manual'],
    notes: 'Regular Sunday calls, preparing for overnight visit.',
    createdAt: '2024-12-01T15:10:00.000Z',
    updatedAt: '2025-01-06T20:31:00.000Z'
  },
  {
    _id: 'member-002',
    childId: 'child-001',
    name: 'Marcus Johnson',
    relationshipToChild: 'Maternal Uncle',
    role: 'emotional',
    phones: ['+1 (555) 998-4477'],
    emails: ['marcus.johnson@example.com'],
    addresses: ['904 Ridge Rd, Topeka, KS'],
    commitmentLevel: 'medium',
    childComfort: 'high',
    caregiverOpenness: 'high',
    status: 'engaged',
    lastContactAt: '2024-12-20T18:00:00.000Z',
    sourceProvenance: ['mock-people-search'],
    notes: 'Coaches basketball; exploring weekend hosting.',
    createdAt: '2024-12-15T12:22:00.000Z',
    updatedAt: '2024-12-20T18:00:00.000Z'
  },
  {
    _id: 'member-003',
    childId: 'child-001',
    name: 'Elena Ramirez',
    relationshipToChild: 'School Counselor',
    role: 'advocacy',
    phones: ['+1 (555) 555-0181'],
    emails: ['elena.ramirez@usd259.org'],
    addresses: ['Carter Middle School, Wichita, KS'],
    commitmentLevel: 'medium',
    childComfort: 'medium',
    caregiverOpenness: 'medium',
    status: 'engaged',
    lastContactAt: '2024-11-18T17:45:00.000Z',
    sourceProvenance: ['school-records'],
    notes: 'Meets weekly, coordinates academic supports.',
    createdAt: '2024-11-01T16:00:00.000Z',
    updatedAt: '2024-11-18T17:45:00.000Z'
  },
  {
    _id: 'member-004',
    childId: 'child-001',
    name: 'Samuel Brooks',
    relationshipToChild: 'Maternal Grandfather',
    role: 'practical',
    phones: ['+1 (555) 774-2201'],
    emails: ['samuel.brooks@example.com'],
    addresses: ['Hutchinson, KS'],
    commitmentLevel: 'low',
    childComfort: 'medium',
    caregiverOpenness: 'medium',
    status: 'engaged',
    lastContactAt: '2024-10-01T12:00:00.000Z',
    sourceProvenance: ['mock-property-search'],
    notes: 'Lives 90 minutes away; open to monthly visits.',
    createdAt: '2024-09-12T15:00:00.000Z',
    updatedAt: '2024-10-01T12:05:00.000Z'
  },
  {
    _id: 'member-005',
    childId: 'child-001',
    name: 'Rachel Kim',
    relationshipToChild: 'Teacher',
    role: 'advocacy',
    phones: ['+1 (555) 311-9922'],
    emails: ['rachel.kim@usd259.org'],
    addresses: ['Carter Middle School, Wichita, KS'],
    commitmentLevel: 'medium',
    childComfort: 'high',
    caregiverOpenness: 'medium',
    status: 'engaged',
    lastContactAt: '2024-08-14T14:15:00.000Z',
    sourceProvenance: ['school-referral'],
    notes: 'Organized school supply drive.',
    createdAt: '2024-08-10T14:00:00.000Z',
    updatedAt: '2024-08-14T14:16:00.000Z'
  }
];

const relationships = [
  {
    _id: 'rel-001',
    childId: 'child-001',
    memberIdA: 'member-001',
    memberIdB: 'member-002',
    type: 'sibling-like',
    strength: 4,
    contactFrequency: 'weekly',
    conflictFlag: false,
    createdAt: '2024-12-15T12:22:00.000Z',
    updatedAt: '2024-12-20T18:00:00.000Z'
  },
  {
    _id: 'rel-002',
    childId: 'child-001',
    memberIdA: 'member-001',
    memberIdB: 'member-004',
    type: 'parent-child',
    strength: 2,
    contactFrequency: 'monthly',
    conflictFlag: true,
    createdAt: '2024-09-12T15:00:00.000Z',
    updatedAt: '2024-10-01T12:05:00.000Z'
  },
  {
    _id: 'rel-003',
    childId: 'child-001',
    memberIdA: 'member-002',
    memberIdB: 'member-004',
    type: 'siblings',
    strength: 3,
    contactFrequency: 'monthly',
    conflictFlag: false,
    createdAt: '2024-10-01T12:00:00.000Z',
    updatedAt: '2024-10-01T12:05:00.000Z'
  }
];

export default {
  members,
  relationships
};
